const Connections = () => {
  return (
    <>
      <div
        id="trends"
        className="flex justify-center text-2xl items-center text-black bg-blue-200 h-screen"
      >
        Page in maintainence ⛏️, will be live soon.
      </div>
    </>
  );
};

export default Connections;
